import { createSlice } from "@reduxjs/toolkit";

/**
 * Estado inicial del store de scanner modal
 */
const initialState = {
  isOpen: false,
};

/**
 * Slice para el modal del scanner
 */
const scannerModalSlice = createSlice({
  name: "scannerModal",
  initialState,
  reducers: {
    openModal: state => {
      state.isOpen = true;
    },
    closeModal: state => {
      state.isOpen = false;
    },
    toggleModal: state => {
      state.isOpen = !state.isOpen;
    },
  },
});

// ===== Exportar acciones =====
export const { openModal, closeModal, toggleModal } = scannerModalSlice.actions;

// ===== Selectores =====
export const selectIsOpen = state => state.scannerModal.isOpen;

// ===== Exportar reducer =====
export default scannerModalSlice.reducer;
